import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AnalyticsService } from 'app/services/auth/analytics.service';
import { AuthService } from 'app/services/auth/auth.service';
import { Web3Service } from 'app/services/web3/web3.service';

@Component({
  selector: 'app-onboarding-layout',
  templateUrl: './onboarding-layout.component.html',
  styleUrls: ['./onboarding-layout.component.scss']
})
export class OnboardingLayoutComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private web3Service: Web3Service

  ) { }

  ngOnInit(): void {
    this.web3Service.getChainId().subscribe((chainID: number) => {
      if ([56, 97].includes(chainID)) this.router.navigate(['migrate-to-polygon'])
    })
    this.authService.signinResponse$.subscribe(res => {
      this.analyticsService.setAnalyticsForLogin(res);
    });
  }

}
